import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

export const MinusThinIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const GapSVG = (
    <svg viewBox="0 0 11.594 1.25" xmlns="http://www.w3.org/2000/svg">
      <rect
        fill={isLight ? theme.color.wh : theme.color.b1}
        height="11.594"
        transform="translate(11.594) rotate(90)"
        width="1.25"
      />
    </svg>
  );

  const AthletaSVG = (
    <svg viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 0v2H0V0z" fill={isLight ? theme.color.wh : theme.color.bk} />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG,
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: null,
    crossBrand: null,
  };
  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
